import React, { FC, LabelHTMLAttributes } from 'react'
import styled from 'styled-components'

const StyledLabel = styled.label`
  display: inline-block;
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 0.8rem;
  color: ${({ theme }) => theme.global.colors.label};
  font-family: ${({ theme }) => theme.global.fontNames.inter};
  line-height: 2.4rem;
`

export const Label: FC<LabelHTMLAttributes<HTMLLabelElement> & { className?: string }> = ({
  className,
  children,
  ...rest
}) => {
  return (
    <StyledLabel className={className} {...rest}>
      {children}
    </StyledLabel>
  )
}
